import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Heading from "./Heading";
import Footer from "./Footer";
import { Button, Container, Stack, ThemeProvider } from "@mui/material";
import getTheme from "./Theme";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useProfileAuthStore } from "./store/ProfileStore";
import { getContentURL, getChannelViewBaseURL } from "./ContentAPI";
import { ContentCardStacks } from "./components/ContentCardStacks";
import { ContentCard } from "./components/ContentCard";
import { getLastFriendImageUrl } from "./store/FriendStore";
import { loadTopRecentChannelImage } from "./store/ChannelStore";
import { authUrl, useCacheBusterStore } from "./util/UrlUtils";
import { loadTopFrontPageImage } from "./store/DiscoveryStore";
import { useLogger } from "./logger";
import { TopButtonMenu } from "./components/TopButtonMenu";
const latestDefaultImage = "./img/latest_512.jpg";
const feedDefaultImage = "./img/feed_512.jpg";
const channelsImg = "./img/channels_512.jpg";
const friendsImg = "./img/friends_512.jpg";
const studioImg = "./img/painter-cat-512.jpg";
const wordcloudImg = "./img/wordcloud_512.jpg";
const LOGPREFIX = "Home: ";
export function Home() {
    const cacheBusterStore = useCacheBusterStore((state) => state);
    const navigate = useNavigate();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [width, setWidth] = useState(0);
    const [feedImage, setFeedImage] = useState();
    const [latestImage, setLatestImage] = useState();
    const [channelsImage, setChannelsImage] = useState();
    const auth = useProfileAuthStore((state) => state);
    const [forceRender, setForceRender] = useState(cacheBusterStore.getCacheBusterNumber());
    const logger = useLogger((state) => state);
    useEffect(() => {
        if (!feedImage && auth.userId) {
            setFeedImage(getContentURL() +
                "/u/" +
                auth.userId +
                "/" +
                auth.userId +
                "/channelImage_512.jpg");
            setForceRender(forceRender + 1);
        }
        return () => { };
    }, [feedImage, auth.userId]);
    useEffect(() => {
        if (!latestImage && auth && auth.isSignedIn()) {
            loadTopFrontPageImage({
                okCallback: function (imageUrl) {
                    if (imageUrl) {
                        logger.log(LOGPREFIX + "Home: latestImage = " + imageUrl);
                        setLatestImage(authUrl(imageUrl, cacheBusterStore, auth));
                    }
                    else {
                        logger.log(LOGPREFIX + "Home: No latest image available, using fallback");
                        setLatestImage(latestDefaultImage);
                    }
                    setForceRender(forceRender + 1);
                },
                errorCallback: function (message) {
                    logger.error(LOGPREFIX + "Unable to load latest trending image - " + message);
                    setLatestImage(latestDefaultImage);
                    setForceRender(forceRender + 1);
                },
            }, cacheBusterStore, logger, auth);
        }
        return () => { };
    }, [latestImage, auth.isSignedIn(), auth.userId]);
    useEffect(() => {
        if (!channelsImage && auth && auth.isSignedIn()) {
            loadTopRecentChannelImage({
                okCallback: function (imageUrl) {
                    if (imageUrl) {
                        logger.log(LOGPREFIX + "Home: channelsImage = " + imageUrl);
                        setChannelsImage(authUrl(imageUrl, cacheBusterStore, auth));
                    }
                    else {
                        logger.log(LOGPREFIX +
                            "Home: No recent channels image available, using fallback");
                        setChannelsImage(channelsImg);
                    }
                    setForceRender(forceRender + 1);
                },
                errorCallback: function (message) {
                    logger.error(LOGPREFIX + "Unable to load recent channels image - " + message);
                    setChannelsImage(channelsImg);
                    setForceRender(forceRender + 1);
                },
            }, auth, cacheBusterStore, logger);
        }
        return () => { };
    }, [channelsImage, auth.isSignedIn(), auth.userId]);
    useEffect(() => {
        //    logger.log(LOGPREFIX+"useEffect: auth - mount");
        if (auth.isSignedIn() && auth.userId) {
            logger.log(LOGPREFIX + "useEffect: auth - user signed in - " + auth.userId);
            // TODO: Need hi-res image to replace profile stock photo
            //      if (profileImageRef.current) {
            //        profileImageRef.current.src = getContentURL() + "/u/" + auth.userId + "/feedImage_512.jpg";
            //      }
        }
        return () => {
            //    logger.log(LOGPREFIX+"useEffect: auth - unmount");
        };
    }, [auth.isSignedIn(), auth.userId]);
    useEffect(() => {
        function handleResize() {
            setWidth(window.innerWidth);
        }
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [setWidth]);
    const latestButton = (_jsx(Button, Object.assign({ sx: { textTransform: "none", margin: 0, padding: 0 }, onClick: () => {
            navigate("/Latest");
        } }, { children: _jsx(ContentCard, { keyStr: "home.latestbutton.card" + latestImage, title: "Latest", backgroundColor: "#FFFFFF", mediaUrl: latestImage ? latestImage : latestDefaultImage, mediaFallbackUrl: latestDefaultImage, textColor: getTheme().palette.violet.main }, "home.latestbutton.card." + latestImage) }), "home.latestbutton." + forceRender + "." + latestImage));
    const feedButton = (_jsx(Button, Object.assign({ sx: { textTransform: "none", margin: 0, padding: 0 }, onClick: () => {
            const displayName = auth === null || auth === void 0 ? void 0 : auth.displayName;
            if (displayName) {
                // Use the complete URL with proper localhost/production handling
                const feedUrl = getChannelViewBaseURL() + encodeURIComponent(displayName);
                window.location.href = feedUrl;
            }
            else {
                navigate("/Feed"); // Fallback to redirect component
            }
        } }, { children: _jsx(ContentCard, { keyStr: "home.feedbutton.card", title: "Feed", backgroundColor: "#FFFFFF", mediaUrl: feedImage, mediaFallbackUrl: feedDefaultImage, textColor: getTheme().palette.violet.main }, "home.feedbutton.card") }), "home.feedbutton." + forceRender));
    let friendsButtonImage = getLastFriendImageUrl();
    if (!friendsButtonImage) {
        friendsButtonImage = friendsImg;
    }
    else {
        friendsButtonImage = authUrl(friendsButtonImage, cacheBusterStore, auth);
    }
    const friendsButton = (_jsx(Button, Object.assign({ sx: { textTransform: "none", margin: 0, padding: 0 }, onClick: () => {
            navigate("/Friends");
        } }, { children: _jsx(ContentCard, { keyStr: "home.friendsbutton.card", backgroundColor: "#FFFFFF", textColor: "#FFFFFF", mediaUrl: friendsButtonImage, mediaFallbackUrl: friendsImg, title: "Friends" }, "home.friendsbutton.card") }), "home.friendsbutton"));
    const channelsButton = (_jsx(Button, Object.assign({ sx: { textTransform: "none", margin: 0, padding: 0 }, onClick: () => {
            navigate("/Channels");
        } }, { children: _jsx(ContentCard, { keyStr: "home.channelsbutton.card" + channelsImage, mediaUrl: channelsImage, mediaFallbackUrl: channelsImg, title: "Channels", textColor: "#FFFFFF", backgroundColor: "#FFFFFF" }, "home.channelsbutton.card." + channelsImage) }), "home.channelsbutton." + forceRender + "." + channelsImage));
    const studioButton = (_jsx(Button, Object.assign({ sx: { textTransform: "none", margin: 0, padding: 0 }, onClick: () => {
            navigate("/Studio");
        } }, { children: _jsx(ContentCard, { keyStr: "home.studiobutton.card", backgroundColor: "#FFFFFF", textColor: "#FFFFFF", mediaUrl: studioImg, mediaFallbackUrl: studioImg, title: "AI Design Studio" }, "home.studiobutton.card") }), "home.studiobutton"));
    const aboutButton = (_jsx(Button, Object.assign({ sx: { textTransform: "none", margin: 0, padding: 0 }, onClick: () => {
            navigate("/About");
        } }, { children: _jsx(ContentCard, { keyStr: "home.aboutbutton.card", backgroundColor: "#FFFFFF", textColor: "#FFFFFF", mediaUrl: wordcloudImg, title: "About Us" }, "home.aboutbutton.card") }), "home.aboutbutton"));
    const adminButton = (_jsx(Button, Object.assign({ sx: { textTransform: "none", margin: 0, padding: 0 }, onClick: () => {
            navigate("/Admin");
        } }, { children: _jsx(ContentCard, { keyStr: "home.adminbutton.card", backgroundColor: "#FFFFFF", textColor: "#FFFFFF", mediaUrl: wordcloudImg, title: "Administration" }, "home.adminbutton.card") }), "home.adminbutton"));
    const cards = [
        latestButton,
        feedButton,
        channelsButton,
        studioButton,
        friendsButton,
        aboutButton,
    ];
    if (auth.accountType == "admin") {
        cards.push(adminButton);
    }
    const content = (_jsx(ContentCardStacks, { keyStr: "home.stack", cards: cards }, "home.stack"));
    const output = (_jsx("div", Object.assign({ style: { width: "100%", height: "100%", padding: 0, margin: 0 } }, { children: _jsxs(ThemeProvider, Object.assign({ theme: getTheme() }, { children: [_jsx(Heading, {}), _jsx(Container, Object.assign({ sx: {
                        backgroundColor: "#FFFFFF",
                        width: "100%",
                        padding: 0,
                        margin: 0,
                    }, maxWidth: false }, { children: _jsxs(Stack, Object.assign({ direction: "column", sx: { width: "100%", display: "flex", justifyContent: "center" } }, { children: [_jsx(TopButtonMenu, { current: undefined }), content] })) })), _jsx(Footer, {})] })) }), "main.div." + forceRender));
    return output;
}
